var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / Note_Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5002 5H9.00024C7.60011 5 6.89953 5 6.36475 5.27248C5.89434 5.51217 5.51217 5.89434 5.27248 6.36475C5 6.89953 5 7.60011 5 9.00024V21.0002C5 22.4004 5 23.1001 5.27248 23.6349C5.51217 24.1053 5.89434 24.4881 6.36475 24.7278C6.899 25 7.59874 25 8.99614 25H21.0039C22.4013 25 23.1 25 23.6342 24.7278C24.1046 24.4881 24.4881 24.1049 24.7278 23.6345C25 23.1002 25 22.4013 25 21.0039V17.5M20 6.25L12.5 13.75V17.5H16.25L23.75 10M20 6.25L23.75 2.5L27.5 6.25L23.75 10M20 6.25L23.75 10",
    stroke: "#0F0D0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.338ce22633c03eadd44f6cd26b2162e3.svg";
export { ForwardRef as ReactComponent };